var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading_documento_finalizacion)?_c('div',{staticClass:"d-flex justify-center"},[_c('v-progress-circular',{attrs:{"size":70,"width":7,"color":"#142638","indeterminate":""}})],1):_c('embed',{attrs:{"src":_vm.src_contrato}})])
}
var staticRenderFns = []

export { render, staticRenderFns }